import React from 'react';

interface AreaInputProps {
  value: number;
  onChange: (area: number) => void;
}

const INPUT: React.CSSProperties = {
  border: '0.5px solid var(--color-border)',
  borderRadius: 'var(--radius-md)',
  padding: '10px 14px',
  fontSize: 13,
  color: '#1E1148',
  outline: 'none',
  background: 'white',
  flex: 1,
};

const AreaInput: React.FC<AreaInputProps> = ({ value, onChange }) => {
  return (
    <div style={{ marginTop: 16 }}>
      <label style={{
        fontSize: 11, fontWeight: 500, color: '#7C6FA0',
        textTransform: 'uppercase', letterSpacing: '0.06em',
        marginBottom: 8, display: 'block',
      }}>
        Surface à rénover
      </label>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <input
          type="number"
          value={value || ''}
          onChange={(e) => onChange(parseInt(e.target.value) || 0)}
          min="0"
          step="0.5"
          style={INPUT}
          placeholder="Ex : 65"
          required
        />
        <span style={{ fontSize: 13, color: '#7C6FA0', whiteSpace: 'nowrap' }}>m²</span>
      </div>
      <p style={{ fontSize: 11, color: '#B8B0CC', marginTop: 6 }}>
        Surface totale concernée par les travaux
      </p>
    </div>
  );
};

export default AreaInput;
